import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './OverviewSectionWrapper.styles'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { LabraToolTipV2 } from '@labrav/react-components'

export type headerAlignmentType = 'normal'
interface OverviewSectionWrapperProps {
  heading: string
  children: JSX.Element
  icon?: IconProp
  actionLabel?: string
  handleAction?: () => void
  infoTooltip?: string
  removeBottomBorder?: boolean
  removeTopBorder?: boolean
  headerAlignment?: headerAlignmentType
}

export const OverviewSectionWrapper = ({
  icon,
  heading,
  actionLabel,
  handleAction,
  children,
  infoTooltip,
  removeBottomBorder,
  removeTopBorder,
  headerAlignment,
}: OverviewSectionWrapperProps) => {
  const { classes } = useStyles({
    removeBottomBorder,
    removeTopBorder,
    headerAlignment,
  })
  return (
    <div className={classes.root} data-testid={'overview-section-wrapper'}>
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          {icon && (
            <div className={classes.iconContainer}>
              <FontAwesomeIcon
                icon={icon}
                style={{ width: '18px', height: '14px' }}
              />
            </div>
          )}
          <div className={classes.headerTextIcon}>
            <div className={classes.heading}>{heading}</div>
            {infoTooltip && (
              <div className={classes.infoIcon}>
                <LabraToolTipV2
                  tooltipPlacement={'bottom-start'}
                  description={infoTooltip}
                  tooltipPlacmentGap="12px"
                >
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    style={{
                      height: 16,
                      color: '#6A777A',
                      width: 16,
                      display: 'flex',
                    }}
                  />
                </LabraToolTipV2>
              </div>
            )}
          </div>
        </div>
        {actionLabel && handleAction && (
          <div className={classes.link} onClick={handleAction}>
            {actionLabel}
          </div>
        )}
      </div>
      {children}
    </div>
  )
}
